import React from "react";
import PropTypes from "prop-types";
import { categoryType } from "custom-prop-types";
import styles from "components/common/edit-columns-modal.scss";
import { Modal } from "components/common/modal";
import { Button } from "components/common/button";
import { findIntegrationInUse } from "utils/check-integration";
import { pluralize } from "utils/string-helpers";

export const ExportModal = ({
  accountId,
  accountSlug,
  categories,
  glCodes,
  isExportMode,
  onClose,
  onExportAll,
  onExportSelected,
  onLinkAccount,
  selectedDocumentIds
}) => (
  <Modal
    isVisible={ isExportMode }
    onClose={ onClose }
    transitionName={ "export-modal" }
  >
    {renderExportText(categories, selectedDocumentIds)}
    <div className={ styles.actions }>
      <Button link onClick={ onClose }>cancel</Button>
      {renderExportButton(
          accountId,
          accountSlug,
          onExportAll,
          onExportSelected,
          glCodes,
          selectedDocumentIds,
          onLinkAccount
        )}
    </div>
  </Modal>
  );

ExportModal.defaultProps = {
  selectedDocumentIds: []
};

ExportModal.propTypes = {
  accountId: PropTypes.string.isRequired,
  accountSlug: PropTypes.string.isRequired,
  categories: PropTypes.arrayOf(categoryType).isRequired,
  glCodes: PropTypes.arrayOf(categoryType).isRequired,
  isExportMode: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onExportAll: PropTypes.func.isRequired,
  onExportSelected: PropTypes.func.isRequired,
  onLinkAccount: PropTypes.func.isRequired,
  selectedDocumentIds: PropTypes.arrayOf(PropTypes.string)
};

const renderExportText = (categories, selectedDocumentIds) => {
  const activeIntegration = findIntegrationInUse(categories);
  if (selectedDocumentIds.length > 0) {
    return (
      <h3>
        Export {pluralize(selectedDocumentIds.length, "documents", "document")} to {activeIntegration}?
      </h3>
    );
  }
  return <h3>Export all documents to {activeIntegration}?</h3>;
};

const renderExportButton = (
  accountId,
  accountSlug,
  onExportAll,
  onExportSelected,
  glCodes,
  selectedDocumentIds,
  onLinkAccount
) => {
  // TODO: This is a temporary fix until the API call for GET integration details is created.
  // Until then we have to judge whether or not an integration exists based on the existence of GL codes.
  if (glCodes.length === 0) {
    return <Button onClick={ () => onLinkAccount(accountSlug) } primary>Link your accounting software</Button>;
  }
  if (selectedDocumentIds.length > 0) {
    return <Button onClick={ () => onExportSelected(accountId, selectedDocumentIds) } primary>Export Selected</Button>;
  }
  return <Button onClick={ () => onExportAll(accountId) } primary>Export All</Button>;
};



// WEBPACK FOOTER //
// ./src/js/components/documents/documents-grid/export-modal.jsx